export const serviceNeedOptions = [
  "D2C fulfillment",
  "B2B distribution",
  "Amazon FBA prep",
  "Retail compliance",
  "Returns management",
  "Cross-docking",
  "Kitting and assembly",
  "Temperature-controlled storage"
];

export const salesChannelOptions = [
  "Shopify",
  "Amazon",
  "TikTok Shop",
  "WooCommerce",
  "Walmart Marketplace",
  "eBay",
  "B2B wholesale",
  "Custom ERP / EDI"
];

export const productCategoryOptions = [
  "Apparel",
  "Beauty and wellness",
  "Consumer electronics",
  "Food and beverage",
  "Healthcare",
  "Home goods",
  "Industrial products",
  "Oversized goods"
];

export const storageTypeOptions = [
  "Ambient",
  "Temperature controlled",
  "Hazmat capable",
  "High-value secure storage",
  "Bulk pallet storage"
];

export const contactMethodOptions = ["Email", "Phone", "WhatsApp", "Video call"];

export const orderBandOptions = [
  "Under 500 orders/month",
  "500 - 2,000 orders/month",
  "2,000 - 10,000 orders/month",
  "10,000 - 50,000 orders/month",
  "50,000+ orders/month"
];

export const roleOptions = [
  "Brand / Merchant",
  "Procurement / Operations",
  "Distributor / Wholesaler",
  "Enterprise supply chain team",
  "Startup founder"
];

export const timelineOptions = [
  "Immediately",
  "Within 30 days",
  "Within 60 days",
  "This quarter",
  "Researching options"
];
